export const findDateDiff = (fromDate: Date | null, toDate: Date | null) => {
  if (fromDate == null || toDate == null) return null;

  let dateDiff: any = toDate?.getTime() - fromDate?.getTime();
  return {
    dateDiff,
  };
};

export const convertLocalDateToUTCIgnoringTimezone = (
  date?: Date
): Date | null => {
  if (date) {
    let offsetInMs = date.getTimezoneOffset() * 60 * 1000;
    return new Date(date.getTime() + offsetInMs);
  } else {
    return null;
  }
};
